import axios from "../helpers/axioxInstance";
import URLS from "../constData/urls";

export const fetchDrmReportDetails = async ({
  pageNum = 1,
  pageSize = 10,
  requestBody,
  controller,
}) => {
  const config = controller ? { signal: controller.signal } : {};

  const response = await axios.post(
    `${URLS.DRM_REPORT_DETAILS}?pageNum=${pageNum}&pageSize=${pageSize}`,
    requestBody,
    config
  );

  if (response.status >= 400) {
    throw new Error(response.statusText || "Failed to fetch report details");
  }

  return response.data;
};
